/**
 * Modules: parts of Teamna an owner turns on or off in Settings, Modules (2026-11-03). A module is
 * off until the owner turns it on. Each module keeps its switch in `businesses.settings` under the
 * key in `MODULE_SETTING`; read it with `moduleOn`, never with the key, so the default stays in one
 * place.
 *
 * - `coaches_add_participants`: coaches type the names of the participants they teach under their
 *   groups, and the Staff page has the card that asks them (coach-adds-swimmers, 2026-10-09).
 */
export const businessModules = ["coaches_add_participants"] as const;
export type BusinessModule = (typeof businessModules)[number];

export const MODULE_SETTING = {
  coaches_add_participants: "staffCanAddParticipants",
} as const satisfies Record<BusinessModule, string>;

type ModuleSettings = { [K in (typeof MODULE_SETTING)[BusinessModule]]?: boolean | null };

/** True only when the owner turned the module on. A missing value is off. */
export function moduleOn(settings: ModuleSettings | null | undefined, module: BusinessModule): boolean {
  return settings?.[MODULE_SETTING[module]] === true;
}

/** The modules a save turned on or off, in `businessModules` order. */
export function changedModules(
  before: ModuleSettings | null | undefined,
  after: ModuleSettings | null | undefined,
): { module: BusinessModule; on: boolean }[] {
  return businessModules
    .filter((module) => moduleOn(before, module) !== moduleOn(after, module))
    .map((module) => ({ module, on: moduleOn(after, module) }));
}
